import { useEffect } from 'react';
import { useHistory } from "react-router-dom";

export const useSetReferrerURL = () => {
  useEffect(() => {
    sessionStorage.setItem('referrerURL', (window.top?.location.pathname || '') + (window.top?.location.search || ''))
  }, [])
}

export const useCleanReferrerTillOTP = () => {
  const history = useHistory();

  useEffect(() => {
    const otpAlreadyUsed = sessionStorage.getItem('otpAlreadyUsed');
    if (otpAlreadyUsed) {
      const referrerURL = sessionStorage.getItem('referrerURL');
      if (referrerURL) {
        sessionStorage.removeItem('referrerURL')
        history.push(referrerURL);
      }
      cleanOTPAlreadyUsed();
    } else {
      sessionStorage.setItem('otpAlreadyUsed', 'true')
    }

    return () => {
      cleanOTPAlreadyUsed();
    }
  }, [history])
}

export const cleanOTPAlreadyUsed = () => {
  sessionStorage.removeItem('otpAlreadyUsed')
}
